export const testIds = {
  container: 'siteMembers.container',
  inlineErrorMsg: 'siteMembers.inlineErrorMsg',
  input: 'siteMembers.input',
};
